import React, { useState, useEffect, useMemo, useCallback } from "react";
import useUI from "hooks/ui.hook";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
  Tag,
} from "lib/components";

import firebase from "services/firebase";

const firestore = firebase.firestore;

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faUserTimes, } from "@fortawesome/free-solid-svg-icons";
import { CategorySelector } from "../../../router_components";
import { useMenu } from "../../../router_context";

import deepClone from "helpers/deepClone";
import moment from "moment";
import deepEqual from "deep-equal";
import styles from "../../../Basic/Assets/scss/modalReservation.module.scss";
import { findSubscriptionNameForDate } from "../../../helpers/operations";

const colors = ["#8c66dc", "#dc6681", "#00bfb2", "#DC965A", "#81171B"];
const colorUnite = "#123865";

const ModalReservation = () => {
  const [ui] = useUI();
  const [ctx, dispatch] = useMenu();

  const [reservation, setReservation] = useState([]);
  const [empty, setEmpty] = useState(false);
  const [page, setPage] = useState(0);

  //aliases
  const template = ui.establishment.template;
  const templateSubscription = ui.establishment.templateSubscription;
  const isEmployee = ui.user.role === "employee";
  const currentUser = ui.user;
  const dataDay = ctx?.data[ctx?.selectedDate];
  const isRestaurantOpen = ui.establishment.isRestaurantOpen ?? true;
  const subscription = findSubscriptionNameForDate(ctx.isMenuV2, currentUser, ctx?.selectedDate, ctx?.modalInfos?.repas);

  const sortedReservation = useMemo(() => {
    return reservation.sort((a, b) => {
      const userA = currentUser?.uid === a?.uid ? currentUser : ctx?.guests.find(_guest => _guest.uid === a?.uid);
      const userB = currentUser?.uid === b?.uid ? currentUser : ctx?.guests.find(_guest => _guest.uid === b?.uid);

      if(!userA?.count) return -1;
      if(!userB?.count) return 1;

      return userA.count - userB.count;
    });
  }, [reservation, currentUser, ctx?.guests]);

  // console.log(ui);
  useEffect(() => {
    if (!ctx.reservationObject) {
      try {
        setPage(0);
        const guestResa = Object.entries(ctx.data[ctx?.selectedDate].reservation)
          .filter(([idResa, resa]) =>
            resa?.[ctx.modalInfos.repas]?.find(_resa => _resa.isGuest)
            && ctx.guests.find(_guest => _guest.uid === idResa)?.linkedTo === ui.user.uid
          )
          .map(([idResa, resa]) => ({ uid: idResa, ...resa[ctx.modalInfos.repas][0] }));

        const _resa = [...deepClone(ctx.data[ctx.selectedDate].reservation[ui?.user?.uid][ctx.modalInfos.repas]), ...guestResa];

        if (_resa) {
          setReservation(_resa);

          if (_resa[0] && _resa[0].status !== "canceled") {
            setEmpty(false);
          } else {
            setEmpty(true);
          }
        } else {
          setReservation([defaultReservationObject()]);
          setEmpty(true);
        }

      } catch (error) {
        setReservation([defaultReservationObject()]);
        setEmpty(true);
        setPage(0);
      }
    }
  }, [ctx.selectedDate, ui?.user?.uid, ctx.modalInfos.repas]);


  const defaultReservationObject = () => {
    const _defaultMenu = {};
    template[ctx.modalInfos.repas].categories.map((_categ) => _defaultMenu[_categ] = null);
    _defaultMenu["supplément"] = null;

    const _resaObj = {
      ..._defaultMenu,
      homeDelivery: (ctx.modalInfos.repas === "Dîner" && isRestaurantOpen === false) ? true : reservation?.[0]?.homeDelivery ?? false,
      ...(currentUser.role === "guest" && { isGuest: true }),
      ...(currentUser.role === "guest" && { uid: ctx?.modalInfos?.uid })
    };

    // console.log( ctx.modalInfos.repas, ctx.modalInfos.repas === "Dîner", isRestaurantOpen , ctx.modalInfos.repas === "Dîner" && isRestaurantOpen === false);
    return _resaObj;
  };

  const _save = () => {
    // ctx.updateMenu(reservation);
    // dispatch({ type: "setProperty", property : "modalResaOpen", value:false});
    // dispatch({ type: "setProperty", property : "modalInfos", value:null});
    dispatch({ type: "setProperty", property: "reservationObject", value: reservation });
    dispatch({ type: "setProperty", property: "modalValidation", value: "save" });
    dispatch({ type: "setProperty", property: "modalResaOpen", value: false });
    dispatch({ type: "setProperty", property: "modalResumeOpen", value: true });
  };

  const _delete = () => {
    // if(confirm("Voulez vous vraiment supprimer votre réservation ?")){
    // ctx.updateMenu("delete");
    // dispatch({ type: "setProperty", property : "modalResaOpen", value:false});
    // dispatch({ type: "setProperty", property : "modalInfos", value:null});
    dispatch({ type: "setProperty", property: "modalValidation", value: "delete" });
    dispatch({ type: "setProperty", property: "modalResaOpen", value: false });
    dispatch({ type: "setProperty", property: "modalResumeOpen", value: true });
    // }
  };



  const updateHomeDelivery = () => {
    let currentValue = reservation[0].homeDelivery;

    let _resa = deepClone(reservation);

    _resa.forEach(element => {
      element.homeDelivery = !currentValue;
    });

    setReservation(_resa);
  };

  const updateSelection = (category, choice) => {
    let currentResa = deepClone(reservation);

    if (["garniture", "dessert"].includes(category)) {
      if (!currentResa[page][category])
        currentResa[page][category] = [];
      // Cas où on l'a déjà séléctionné => on le retire
      if (currentResa[page][category].includes(choice)) {
        currentResa[page][category] = currentResa[page][category].filter((item) => item !== choice);
      } else {
        // sinon on l'ajoute
        if (typeof currentResa[page][category] === "string") currentResa[page][category] = [currentResa[page][category]];
        currentResa[page][category] = [...currentResa[page][category], choice];

      }
    } else {
      currentResa[page][category] = choice;

    }

    setReservation(currentResa);
  };

  const addResa = (uid) => {
    let currentResa = deepClone(reservation);

    if (reservation.find(resa => resa.uid === uid)) return;
    currentResa.push({
      ...defaultReservationObject(),
      isGuest: true,
      uid: uid,
    });

    setReservation(currentResa);
    setPage(currentResa.length - 1);
  };

  const removeResa = () => {
    let indxToRemove = page > 0 ? page : null;

    if (indxToRemove) {
      let currentResa = deepClone(reservation);

      currentResa.splice(indxToRemove, 1);

      setReservation(currentResa);
      setPage(page - 1);
    }
  };

  const retour = () => {

    if (ctx.modalValidation === "modification") {
      dispatch({ type: "setProperty", property: "modalResaOpen", value: false });
      dispatch({ type: "setProperty", property: "modalResumeOpen", value: true });
    } else {
      dispatch({ type: "setProperty", property: "modalResaOpen", value: false });
    }
  };

  const hasChanged = useMemo(() => {
    let _initial = [];

    // On compare la resa actuelle à la resa initiale :
    if (ctx.data[ctx.selectedDate] && ctx.data[ctx.selectedDate].reservation && ctx.data[ctx.selectedDate].reservation[ui.user.uid]) {
      const userResa = ctx.data[ctx.selectedDate].reservation[ui.user.uid][ctx.modalInfos.repas];
      const guestResa = Object.entries(ctx.data[ctx?.selectedDate].reservation)
        .filter(([idResa, resa]) =>
          resa?.[ctx.modalInfos.repas]?.find(_resa => _resa.isGuest)
          && ctx.guests.find(_guest => _guest.uid === idResa)?.linkedTo === ui.user.uid
        )
        .map(([idResa, resa]) => ({ uid: idResa, ...resa[ctx.modalInfos.repas][0] }));

      _initial = [...userResa ?? [], ...guestResa];
    }

    if (deepEqual(_initial, reservation)) {
      return false;
    } else {
      return true;
    }
  }, [reservation, ctx]);


  const getFormula = useCallback((_page) => {
    if (ctx.modalInfos.repas === "Déjeuner") {
      let count = 0;
      if (reservation[_page]) {

        if (reservation[_page]["entrée"]) count++;
        if (reservation[_page]["plat"]) count++;
        if (reservation[_page]["dessert"]) count++;
      }

      if (count === 2) return "DUO";
      if (count === 3) return "TRIO";

      return null;
    }
    if (ctx.modalInfos.repas === "Dîner") {
      let count = 0;
      if (reservation[_page]) {

        if (reservation[_page]["entrée"]) count++;
        if (reservation[_page]["plat"]) count++;
        if (reservation[_page]["dessert"]) count++;
      }

      if (count >= 2) return "DUO";
      return null;
    }
    return null;
  }, [reservation, ctx]);


  const isValid = useMemo(() => {
    let _valid = true;

    reservation.forEach((_resa, _page) => {
      if (reservation[0].homeDelivery === true) {
        if (!getFormula(_page)) _valid = false;
      }
    });

    return _valid;
  }, [reservation, ctx]);

  const addGuest = async () => {
    const allUserGuests = ctx?.guests.filter(_user => _user.type === "resident" && _user.linkedTo === currentUser.uid && _user.count).sort((a, b) => a.count - b.count);

    let guestId;

    const reservationIds = reservation.map(_resa => _resa?.uid ? _resa.uid : currentUser.uid);

    for(const _userGuest of allUserGuests){
      if(!reservationIds.includes(_userGuest.uid)){
        guestId = _userGuest.uid;
        break;
      }
    }
    
    if(!guestId){
      const data = {
        name: "",
        surname: "",
        type: "resident",
        linkedTo: currentUser.uid,
        role: "guest",
        establishment: ui.user.establishment,
        createdAt: new Date(),
        count: allUserGuests.length + 1,
      }
      
      const result = await firestore()
      .collection("users")
      .add(data);
      
      guestId = result.id;
    }
    
    addResa(guestId);
  };

  return (
    <Modal isOpen={ctx.modalResaOpen} toggle={() => dispatch({ type: "setProperty", property: "modalResaOpen", value: false })} className={styles.modal}>
      <ModalHeader className={styles.modalHeader}>
        <div className={styles.modalHeaderComponent}>
          <div className={styles.headerInfo}></div>

          <div className={styles.modalTitle}>
            Réservation pour le {ctx.modalInfos.repas} du <span className={styles.headerDate}>{moment(ctx?.selectedDate).format("dddd DD MMMM")}</span>
          </div>

          <div className={styles.headerContent}>
            {page === 0 && templateSubscription ?
              subscription ?
                subscription === "1/2p Duo" ?
                  <div>
                    <Tag className={styles.tag} style={{ backgroundColor: colors[0] }}><div>Demi Pension</div></Tag>
                    <Tag className={styles.tag} style={{ backgroundColor: colors[1] }}><div>DUO</div></Tag>
                  </div>
                  :
                  subscription === "1/2p Trio" ?
                    <div>
                      <Tag className={styles.tag} style={{ backgroundColor: colors[0] }}><div>Demi Pension</div></Tag>
                      <Tag className={styles.tag} style={{ backgroundColor: colors[2] }}><div>TRIO</div></Tag>
                    </div>
                    : null
                :
                <Tag className={styles.tag} style={{ backgroundColor: colorUnite }}><div>Unité</div></Tag>

              : null}
          </div>

        </div>
      </ModalHeader>

      <ModalBody className={styles.modalBody}>
        {reservation &&
          <div className={styles.modalContainer}>
            <div className={styles.headerResa}>
              <div className={styles.resaList}>
                <div className={page === 0 ? styles.resaSelected : null} onClick={() => setPage(0)}> {currentUser?.surname} {currentUser?.name}</div>
                {/* {reservation.length > 1 ?
                  reservation.map((_r, indx) => (
                    indx > 0 ?
                      <div key={indx} onClick={() => setPage(indx)} className={page === indx ? styles.resaSelected : null}>
                        <div>
                          {ctx.guests.find(g => g.uid === _r?.uid)?.name} {ctx.guests.find(g => g.uid === _r?.uid)?.surname}
                        </div>
                      </div>
                      : null
                  ))
                  : null} */}
                  {sortedReservation.length > 1 ?
                    sortedReservation.map((_r, indx) => (
                      indx > 0 ?
                        <div key={indx} onClick={() => setPage(reservation.indexOf(_r))} className={page === reservation.indexOf(_r) ? styles.resaSelected : null}>
                          <div>
                            {ctx.guests.find(_guest => _guest.uid === _r?.uid)?.count ? `Invité ${ctx.guests.find(_guest => _guest.uid === _r?.uid).count}` : `${ctx.guests.find(_guest => _guest.uid === _r?.uid)?.name} ${ctx.guests.find(_guest => _guest.uid === _r?.uid)?.surname}`}
                          </div>
                        </div>
                        : null
                    )) : null}
              </div>
              <div className={styles.resaButton}>
                {!isEmployee ?
                  <>
                    {page > 0 ? <div color="danger" onClick={removeResa} style={{ color: "red" }}> <FontAwesomeIcon icon={faUserTimes} color="red" /> Supprimer cette invitation</div> : null}
                    <div onClick={addGuest}> <FontAwesomeIcon icon={faUserPlus} color="#300438" /> Inviter une personne</div>
                  </>
                  : null}
              </div>
            </div>
            {/* <ModalInformation reservation={reservation} page={page} /> */}
            {reservation[0]?.homeDelivery ?
              <div className={styles.content}>


                <CategorySelector page={page} dataReservation={reservation[page]} updateSelection={(category, choice) => updateSelection(category, choice)} />
              </div>
              :
              <div className={styles.noDetails}>
                Réservation d'une place pour le restaurant
              </div>
            }

          </div>

        }
      </ModalBody>
      <ModalFooter>
        <div className={styles.footer}>
          <div className={styles.footerLeft}>
            <div className={styles.nbresas}>
              Total : {reservation ? reservation.length : 0} repas
            </div>
            {!isEmployee ? <div>
              <Checkbox className={styles.checkbox} label="portage" checked={reservation ? reservation[0]?.homeDelivery : false} disabled={!isRestaurantOpen && ctx.modalInfos.repas === "Dîner"} onChange={updateHomeDelivery} />
            </div> : <div></div>}
          </div>

          <div className={styles.footerInfos}>
            {!isValid ?
              <div className={styles.notValid}>
                Touchez les plats que vous voulez réserver. <br /> Vous devez compléter une formule {reservation.length > 1 ? "(pour chaque invité)" : null}.
              </div> : null}
          </div>

          <div className={styles.footerButtons}>
            {!empty && !(reservation && reservation[0] && reservation[0].createdLocally) ?
              <Button color="danger" onClick={_delete}>Supprimer</Button>
              : null}
            <Button color="secondary" onClick={retour}>Retour</Button>
            {dataDay ? <Button color="primary" disabled={!hasChanged || !isValid} onClick={_save}>Valider</Button> : null}
          </div>

        </div>
      </ModalFooter>
    </Modal>
  );
};

const SuspenseHOC = (props) => {
  const [ctx] = useMenu();

  if (!ctx || !ctx.data || !ctx.modalInfos) return <></>;
  return <ModalReservation {...props} />;
};


export default SuspenseHOC;
